import { Avatar } from '@mui/material'

type Props = {
  thumbnailImagePath: string
  thumbnailImageSize: number
}

export function GameThumbnail({
  thumbnailImagePath,
  thumbnailImageSize,
}: Props) {
  return (
    <Avatar
      variant="rounded"
      src={`${process.env.PUBLIC_URL}/${thumbnailImagePath}`}
      sx={{
        marginRight: 0,
        marginLeft: 0,
        borderRadius: thumbnailImageSize / 24,
        borderWidth: 2,
        borderStyle: 'solid',
        borderColor: 'rgba(0,0,0,0.4)',
        width: thumbnailImageSize,
        height: thumbnailImageSize,
      }}
    />
  )
}
